package one.healthium.insights.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.PlayArrow
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.items.Hint
import one.healthium.ui.NetworkImage
import one.healthium.ui.compose.theme.AppTheme

@Composable
internal fun ContentCard(
    modifier: Modifier = Modifier,
    item: ContentEntry.CardEntry,
    onActionClicked: (ActionModel) -> Unit,
) {
    Box(
        modifier = modifier
            .padding(horizontal = 12.dp, vertical = 6.dp)
            .fillMaxWidth()
            .height(128.dp)
            .background(AppTheme.colors.primary, AppTheme.shapes.medium)
            .clip(AppTheme.shapes.medium)
            .clickable { onActionClicked(item.action) }
    ) {
        if (item.imageUrl != null) {
            NetworkImage(
                imageUrl = item.imageUrl,
                modifier = Modifier.Companion.fillMaxSize(),
                contentScale = ContentScale.Companion.Crop,
            )
        }

        Row(
            modifier = Modifier.Companion
                .fillMaxSize()
                .padding(horizontal = 20.dp),
            verticalAlignment = Alignment.Companion.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            Column(
                modifier = Modifier.Companion.weight(1f),
                verticalArrangement = Arrangement.Center,
            ) {
                Spacer(Modifier.Companion.height(12.dp))
                Text(
                    text = item.title ?: "",
                    style = AppTheme.contentCardStyle?.titleStyle ?: AppTheme.textStyles.poppins20,
                    color = AppTheme.colors.textInverted100,
                )
                Spacer(Modifier.Companion.height(12.dp))
                Hint(item.hint)
                Spacer(Modifier.Companion.height(12.dp))
            }
            when (val action = item.action) {
                is ActionModel.Video -> {
                    PlayButton(onClick = { onActionClicked(action) })
                }

                else -> {}
            }
        }
    }
}

@Composable
private fun PlayButton(onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .size(40.dp)
            .clip(CircleShape)
            .background(AppTheme.colors.primary, CircleShape)
            .clickable { onClick() },
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            imageVector = Icons.Default.PlayArrow,
            contentDescription = null,
            tint = AppTheme.colors.onPrimary,
        )
    }
}
